module.exports = __webpack_public_path__ + "img/biominder-keymap-wire.63faaea0.png";